<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {
  },
  data:()=>({
  }),
}
</script>
<style>
.vs-table--search-input{
  border: 0.5px solid rgb(43 43 43 / 49%);
  border-radius: 8px;
}
.vs-table--thead tr th{
  background: rgb(223 198 146 / 20%);
}
</style>